/**
 * heroRotation — daily-rotating H1 for the landing hero.
 *
 * Rotates through a curated pool of SEO-optimised, pain-led / benefit-led
 * headlines that all fit the same visual template:
 *
 *   {line1}
 *   {gradient}  ← rendered with the emerald→teal→sky gradient
 *
 * Selection is deterministic by day-of-year so every visitor sees the
 * same headline on the same UTC day. Rotate the pool by editing the
 * `HEADLINES` array — no code changes needed elsewhere.
 *
 * Keywords targeted across the pool (helps Google understand the page
 * is *the* Canadian rental software regardless of the phrasing that
 * happens to be visible today):
 *   - property management software canada
 *   - collect rent online canada
 *   - canadian landlord software
 *   - small landlord app
 *   - t776 tax software
 *   - tenant screening canada
 *   - provincial lease generator
 */
const HEADLINES = [
  { line1: "Stop chasing rent",              gradient: "by text.",                          eyebrow: "For Canadian landlords" },
  { line1: "The Canadian property OS",       gradient: "for busy landlords.",               eyebrow: "Built in Canada" },
  { line1: "Collect rent in CAD",            gradient: "on autopilot.",                     eyebrow: "PIPEDA compliant" },
  { line1: "Property management software",   gradient: "for Canadian landlords.",           eyebrow: "All 13 provinces" },
  { line1: "Screen tenants, sign leases,",   gradient: "collect rent — one app.",           eyebrow: "The Canadian rental OS" },
  { line1: "Small-landlord software",        gradient: "built for Canada.",                 eyebrow: "1 to 500 units" },
  { line1: "Your rent, your leases,",        gradient: "your dashboard.",                   eyebrow: "For Canadian landlords" },
  { line1: "T776-ready books,",              gradient: "without the shoebox.",              eyebrow: "CRA-friendly reports" },
  { line1: "The last rental spreadsheet",    gradient: "you'll ever open.",                 eyebrow: "For Canadian landlords" },
  { line1: "Canadian landlord software",     gradient: "that pays for itself.",             eyebrow: "60 CAD / month" },
  { line1: "Get rent, receipts,",            gradient: "and your weekends back.",           eyebrow: "For Canadian landlords" },
  { line1: "Provincial leases,",             gradient: "signed and stored — in minutes.",   eyebrow: "AB · BC · ON · QC · and more" },
  { line1: "One tap for rent.",              gradient: "One tap for taxes.",                eyebrow: "The Canadian property OS" },
  { line1: "Automatic late fees,",           gradient: "quiet weekends.",                   eyebrow: "For Canadian landlords" },
];

function dayIndex() {
  // Day-of-year (0–365) in UTC — same for every visitor on the same day.
  const now = new Date();
  const start = Date.UTC(now.getUTCFullYear(), 0, 0);
  const diff = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()) - start;
  return Math.floor(diff / 86400000);
}

export function getDailyHeadline() {
  return HEADLINES[dayIndex() % HEADLINES.length];
}
